<template>
    <div>
        <v-btn small class="mx-4" @click="$router.back()" color="info" rounded outlined> <v-icon>mdi-arrow-left-bold</v-icon> :) Volver Atras</v-btn>
        <!-- <router-link to="recibosesamlista"> <span class="glyphicon glyphicon-eye-open"></span> Ver los recibos generados </router-link> -->
        <h3 class="text-center" style="margin-top:0"> Generar Recibo Manual  </h3>
        <form @submit="validar">
            <div class="text-center"> <small>Tomar en cuenta que los campos con <b class="text-danger">* (asterisco)</b> son obligatorios, los demas campos pueden ser vacios o contener al menos 5 caracteres.</small> </div>
            <div class="text-center pt-0 mb-4"> <small> Estos recibos no estan vinvulados al plan de pagos del estudiante </small> </div>
            <div class="row justify-center" style="background:#FbFdFf;">
                <div class="col-sm-4 col-lg-3 text-left" style="padding-left:5%">
                    <p> <b><span class="text-danger">*</span>Lugar:</b> <input v-model.trim="input.lugar" class="form-control" type="text" required> </p>
                    <p> <b><span class="text-danger">*</span>Monto:</b> <input v-model.number="input.monto" class="form-control" type="number" step="0.1" placeholder="en bolivianos..." required> </p>
                    <!-- <p> <b><span class="text-danger">*</span>Estudiante:</b> <input v-model.trim="input.estudiante" class="form-control" type="text" required> </p> -->
                    <p> 
                        <b><span class="text-danger">*</span>Estudiante:</b>
                        <v-combobox
                            v-model="filtroestudiante"
                            :items="estudiantes"
                            label="Carnet estudiante"
                            :loading="isloadingestudent"
                            placeholder="tecla enter para buscar..."
                            hide-details
                            outlined
                            dense />
                    </p>
                    <p> <b>Carnet:</b> <input v-model.trim="input.num_doc" class="form-control" type="text"> <small class="text-danger"> {{cimsg}} </small> </p>
                    <p v-show="false"> <b> Telefono:</b> <input v-model.trim="input.telefono" class="form-control" type="text"> </p>
                    <p> <b>Direccion:</b> <input v-model.trim="input.direccion" class="form-control" type="text"> </p>
                    <p> <b>Zona:</b> <input v-model.trim="input.zona" class="form-control" type="text"> </p>
                </div>
                <div class="col-sm-4 col-lg-3 text-left">
                    <p> <b>Celular:</b> <input v-model.trim="input.celular" class="form-control" type="text"> </p>
                    <p> <b>Nro. Factura:</b> <input v-model.trim="input.nro_factura" class="form-control" type="text" placeholder="de al menos 5 digitos..."> </p>
                    <p> <b><span class="text-danger">*</span>Concepto:</b> <textarea v-model.trim="input.concepto" class="form-control" type="text" rows="3" cols="23" required></textarea> </p>
                    <p> <b><span class="text-danger">*</span>Forma de pago:</b> <textarea v-model.trim="input.forma_pago" class="form-control" type="text" rows="3" cols="23" required></textarea> </p>
                    <p> <b>Saldo:</b> <input v-model.number="input.saldo" class="form-control" type="number" placeholder="en bolivianos..."> </p>
                    <p> <b>Nro. cuota:</b> <input v-model.trim="input.num_cuota" class="form-control" type="text" placeholder="puede separar por comas..."> </p>
                </div>
                <div class="col-sm-4 col-lg-3 text-left" style="padding-right:5%">
                    <p> <b>Proximo pago:</b> <input v-model.trim="input.proximo_pago" class="form-control" type="text"> </p>
                    <p> <b><span class="text-danger">*</span> Emisor:</b> <input v-model.trim="input.emisor" readonly class="form-control" type="text" required> </p>
                    <p> <b>Asesor:</b> <input v-model.trim="input.asesor" class="form-control" type="text"> </p>
                    <p> <b>Fecha de Emision:</b>  <input v-model.trim="input.fecha_pago" disabled="true" type="text" required> </p>
                    <!-- <p> ID sede:  <input v-model.number="input.sede_id" disabled="true" type="text" required> </p> -->
                    <p>
                        <v-select
                            :items="xsedes"
                            v-model="input.sede_destino"
                            item-text="nombre"
                            item-value="id"
                            class="mt-1 ml-1"
                            style="min-width: 150px; max-width: 250px"
                            label="* Sede destino:"
                            outlined
                            dense
                            placeholder="Seleccione..."
                            hide-details
                            return-object />
                    </p>
                </div>
            </div>

            <!-- <div class="row justify-center">
                <div class="col-xs-12 col-sm-10 col-lg-6">
                    <div class="modal-body pt-0" id="content-preview">
                        <div style="width:10px!important;height:10px!important;overflow:hidden">
                            <canvas id="canvasrecibo" width="1280" height="1080"></canvas>
                        </div>
                        <div class="center-block" style="width:100%;height:500px">
                            <canvas id="myCanvasview" style="border:1px solid #55d3d3d3;width:100%;height:100%"></canvas>
                        </div>
                    </div>
                </div>
            </div> -->

            <div class="modal-body pt-0" id="content-preview">
                <div style="width:10px!important;height:10px!important;overflow:hidden">
                    <canvas id="canvasrecibo" width="1280" height="1080"></canvas>
                </div>
                <div class="center-block" style="width:70%;height:540px">
                    <canvas id="myCanvasview" style="border:1px solid #55d3d3d3;width:100%;height:100%"></canvas>
                </div>
            </div>
            

            

            <div class="text-center mb-8">
                <div style="display: inline-block;" v-show="generando" class="loader"></div> 
                <div v-if="generando" class="row justify-center q-px-lg px-5">
                    <v-progress-linear class="q-px-4" indeterminate />
                </div>
                <p class="text-danger"> {{msg}} </p>
                <button :disabled="generando || generado" type="submit" class="btn btn-sm btn-azul oulined mr-4" style="color:white">
                    <svg width="1.1em" height="1.1em" viewBox="0 0 16 16" class="bi bi-printer-fill" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path d="M5 1a2 2 0 0 0-2 2v1h10V3a2 2 0 0 0-2-2H5z"/>
                        <path fill-rule="evenodd" d="M11 9H5a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1z"/>
                        <path fill-rule="evenodd" d="M0 7a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-1v-2a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v2H2a2 2 0 0 1-2-2V7zm2.5 1a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1z"/>
                    </svg>
                    Generar y descargar en PDF 
                </button>
                <button :disabled="generando" type="button" class="btn btn-sm btn-danger oulined" @click="limpiarDatos()" style="color:white">
                    <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-brush-fill" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" d="M15.825.12a.5.5 0 0 1 .132.584c-1.53 3.43-4.743 8.17-7.095 10.64a6.067 6.067 0 0 1-2.373 1.534c-.018.227-.06.538-.16.868-.201.659-.667 1.479-1.708 1.74a8.117 8.117 0 0 1-3.078.132 3.658 3.658 0 0 1-.563-.135 1.382 1.382 0 0 1-.465-.247.714.714 0 0 1-.204-.288.622.622 0 0 1 .004-.443c.095-.245.316-.38.461-.452.393-.197.625-.453.867-.826.094-.144.184-.297.287-.472l.117-.198c.151-.255.326-.54.546-.848.528-.739 1.2-.925 1.746-.896.126.007.243.025.348.048.062-.172.142-.38.238-.608.261-.619.658-1.419 1.187-2.069 2.175-2.67 6.18-6.206 9.117-8.104a.5.5 0 0 1 .596.04z"/>
                    </svg>
                    Limpiar datos 
                </button>
            </div>
        </form>

        <ABuscarPersona ref="abuscarpersona" />
    </div>
</template>


<style>
.inputs{
    border: 1px solid #A3C4D8;
    padding-left: 2px;
    caret-color: #009800;
}
.inputs:focus{
    outline-width: 0;
    border: 1px solid #326E93 !important;
    padding-left: 2px;
    caret-color: #009800;
}
.oulined:focus{
    outline-width: 0;
}
</style>

<script>
import gql from 'graphql-tag';
import ABuscarPersona from '@/components/ABuscarPersona';
import xaxios from '@/xaxios';

export default { 
  data(){
    return{
        usuario:{usuario:{}},
        fondo:null,
        firma:null,
        generando: false,
        generado: false,
        msg:'',
        cimsg:'',
        numero: '',
        timeoutHnd: 0,
        filtroestudiante: '',
        isloadingestudent: false,
        firma_path: process.env.VUE_APP_URL_BG_FIRMA_USER,
        estudiantes: [],
        xsedes:[],
        loadingverificacion: true,
        cajaabierta: false,
        input:{
            lugar: '',
            monto: null,
            estudiante: '',
            num_doc: '',
            telefono: '',
            celular: '',
            concepto: '',
            forma_pago: '',
            saldo: null,
            num_cuota: '',
            direccion: '',
            zona: '',
            proximo_pago: '',
            asesor: '',
            emisor: '',
            recibo_fondo: '',
            sede_id: -1,
            fecha_pago: '',
            nro_factura: '',
            sede_destino: null,
        }
    }
  },
  components:{ABuscarPersona},
  validators: {},
  watch:{
      '$store.state.DATA_USER.nombres': function (){ this.getcurrentusuario(); this.verificar() },
      '$store.state.CARGO.idsede': function (){ this.getcurrentusuario(); this.verificar(); },
      '$store.state.cajaperturada': function (){ this.verificar(); },
      'input':{
          deep: true,
          handler(){ this.cargardatos(); }
      },
      filtroestudiante: function() {
        if (!this.filtroestudiante) {
          this.filtroestudiante = '';
          this.getDatos();
        }
        if (typeof this.filtroestudiante == 'object') {
          this.getDatos();
          return;
        }
        //window.console.log(this.filtroestudiante, typeof this.filtroestudiante);
        if (this.timeoutHnd) {
          clearTimeout(this.timeoutHnd);
          this.timeoutHnd = 0;
        }
        var vue = this;
        this.timeoutHnd = setTimeout(function() {
          if (vue.filtroestudiante.length > 2) {
            vue.estudiantes = [];
            vue.input.estudiante = '';
            vue.input.num_doc = '';
            vue.input.direccion = '';
            vue.input.telefono = '';
            vue.asyncfindestudiante(false);
          } else {
            vue.msg = '';
            vue.estudiantes = [];
          }
          this.timeoutHnd = 0;
        }, 500);
      },
  },
  methods:{
      fechahoy(){
          let date = new Date();
          let d = date.getDate();
          let m = date.getMonth()+1;
          let a = date.getFullYear();
          if( d < 10 ) d = '0'+d;
          if( m < 10 ) m = '0'+m;
          this.input.fecha_pago = d+'/'+m+'/'+a;
      },
      fechaproximopago(){
          let date = new Date();
          date.setDate( 15 );
          date.setMonth( date.getMonth()+1 );
          let d = date.getDate();
          let m = date.getMonth()+1;
          let a = date.getFullYear();
          if( d < 10 ) d = '0'+d;
          if( m < 10 ) m = '0'+m;
          this.input.proximo_pago = d+'/'+m+'/'+a;
      },
      getcurrentusuario(){ 
          let user = this.$store.state.DATA_USER;
          this.input.sede_id = this.$store.state.CARGO.idsede;
          if( user ){
              this.usuario = user;
              if( !user.seg_apellido ) user.seg_apellido = '';
              this.input.asesor = (user.nombres+' '+user.pri_apellido+' '+user.seg_apellido).trim();
              this.input.emisor = (user.nombres+' '+user.pri_apellido+' '+user.seg_apellido).trim();
              if( this.usuario.usuario ) this.cargarfondo();
          }
      },
      voltearfecha( f ){
          if( !f ) return '';
          let partes = f.split('/');
          return partes[2]+'-'+partes[1]+'-'+partes[0];
      },
      validarextensionci(){
          /* let ci = this.input.num_doc;
          if( !ci ) return;
        //   if( /[0-9][a-zA-Z]{1,2}$/.test(ci) ){ 
          if( /^\d+(?:-\d+[a-zA-Z])?$/.test(ci) ){ 
              this.cimsg = 'Formato de ci no valido, no debe terminar con dos letras, puede usar el complemento: 12345678-M';
          }else{
              this.cimsg = '';
          } */
      },
      async verificar(){
        this.msg = ''; 
        this.loadingverificacion = true;
        this.cajaabierta = false;

        const sedeid = this.$store.state.CARGO.sede.id;
        const userid = this.$store.state.DATA_USER.id;
        const url = `${process.env.VUE_APP_API_REST}/api/v1/esam/cajas/abierto/${sedeid}/usuario/${userid}`; 
        const res = await xaxios.get(url).then(x=>x).catch(x=>x); 
        if(res && res.data){
            const data = res.data;
            window.console.log('verif caja:', data); 
            this.cajaabierta = true;
        }else{
            this.$root.$notify.show(`Apertura una caja para poder generar recibos.`, {color:'red',y: 'left',});
        }
        this.loadingverificacion = false;
      },
      asyncfindestudiante() {
        this.$refs.abuscarpersona.asyncfindestudiante(false, this.filtroestudiante, this);
      },
      async getUsuario() { 
        let id = this.$store.state.DATA_USER.id;
        const sql = gql`query{getUsuario(id: ${id}) { id firma ${''}}}`;
        let res = await this.$apollo.query({ query: sql }).then(({ data }) => data);
        const u = res.getUsuario;
        // window.console.log('getUsuario: ',u);

        let canvas = document.getElementById('canvasrecibo');
        let ctx = canvas.getContext('2d');
        const vue = this;
        this.firma = null;
        if(u.firma){
            this.firma = new Image();
            this.firma.setAttribute('crossorigin', 'anonymous');
            // firma_path + asesor.firma
            this.firma.addEventListener('load', function() { 
                ctx.drawImage(vue.firma, 950, 800,250, 250);
            }, false);
            this.firma.src = this.firma_path + u.firma; 
        }
        
      },
      async getsedes(){
        this.xsedes = [];
        var sql = gql`query{getSedes{id,nombre,unidad_negocio}}`;
        let res = await this.$apollo.query({query: sql}).then((data) => data).catch((error) => error);
        // window.console.log('sedes:',res.data.getSedes);
        if(res && res.data) {
            let idsede = this.$store.state.CARGO.sede.id;
            let filtrado = res.data.getSedes.filter(x=>x.id != idsede);
            this.xsedes = filtrado;
        }
      },
      getDatos(){
        // window.console.log(this.filtroestudiante);
        if (typeof this.filtroestudiante == 'object') {
            let est = this.filtroestudiante;
            let nombre = `${est.nombres} ${est.pri_apellido} ${est.seg_apellido}`;
            nombre = nombre.replace('null','');
            this.input.estudiante = nombre;
            this.input.num_doc = est.num_doc;
            if(est.domicilio) this.input.direccion = est.domicilio;
            this.input.telefono = est.telefono1;
        }
      },
      cargarfondo(){
          if( this.fondo && this.input.recibo_fondo ){
              this.cargardatos();
              return;
          }
          var canvas = document.getElementById('canvasrecibo');
          var ctx = canvas.getContext('2d');
          const vue = this;
          this.fondo = new Image();
          this.fondo.setAttribute('crossorigin', 'anonymous');

        //   window.console.error( 'EXISTE::',this.usuario.usuario.firma );
        //   this.fondo.src = "img/recibo-andrea.jpg"; 
        //   this.input.recibo_fondo = "img/recibo-andrea.jpg";
        let unidad = this.$store.state.CARGO.sede.unidad_negocio;
        // window.console.log('>>>>>>>>>>>',unidad);
        if(unidad==10){
            this.fondo.src = "img/recibo-blank-dbs.jpg"; 
            this.input.recibo_fondo = "img/recibo-blank-dbs.jpg";
        }else{
            this.fondo.src = "img/recibo-blank.jpg"; 
            this.input.recibo_fondo = "img/recibo-blank.jpg";
        }
        

          /*if( this.usuario.usuario.firma ){
              this.fondo.src = process.env.VUE_APP_URL_BG_FIRMA_USER+this.usuario.usuario.firma;
              this.input.recibo_fondo = this.usuario.usuario.firma;
          }else{
                var iduser = this.$store.state.DATA_USER.id;
                var fondito = '';
                if (iduser == 31) fondito = 'img/recibo_andrea.png';//
                else if (iduser == 74) fondito = 'img/recibo_celina.jpg';//
                else if (iduser == 10730) fondito = 'img/recibo_grecia.png';//
                else if (iduser == 8740) fondito = 'img/recibo_ecoca.png';//
                else if (iduser == 11155) fondito = 'img/recibo_jtrigo.png';//
                else if (iduser == 3522) fondito = 'img/recibo_pgarcia.png';
                else if (iduser == 1406) fondito = 'img/recibo_pmontoya.png';//
                else if (iduser == 1405) fondito = 'img/recibo_mguevara.png';//
                else if (iduser == 818) fondito = 'img/recibo_oarancibia.png';
                else if (iduser == 18) fondito = 'img/recibo_raquel.png';
                else if (iduser == 3145) fondito = 'img/recibo_afernandez.png';
                else if (iduser == 3506) fondito = 'img/recibo_mcarvajal.png';//
                else if (iduser == 3522) fondito = 'img/recibo_pgarcia.png';//
                else if (iduser == 11004) fondito = 'img/recibo_apacheco.png'; //
                else if (iduser == 11219) fondito = 'img/recibo_grodriguez.png';//
                else if (iduser == 6476) fondito = 'img/recibo_lvasquez.png';//
                else if (iduser == 870) fondito = 'img/recibo_nsoruco.png';//
                else fondito = 'img/recibodemo.jpg';
                window.console.log( 'fondito::',fondito )

                this.fondo.src = fondito; 
                this.input.recibo_fondo = fondito;
          }*/
          this.fondo.addEventListener('load', function() {
              ctx.drawImage(vue.fondo, 0, 0,1280, 1080);
              vue.cargardatos();
            }, false);
      },
      cargardatos(){
          this.validarextensionci();
        var canvas = document.getElementById('canvasrecibo');
        var ctx = canvas.getContext('2d');
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        if( this.fondo ) ctx.drawImage(this.fondo, 0, 0,1280, 1080);
        if( this.firma ) ctx.drawImage(this.firma, 950, 800,250, 250);

        const fs = this.input.fecha_pago.split('/');
        const d = fs[0];
        const m = fs[1];
        const a = fs[2];

        ctx.font = "27px Arial";
        ctx.textAlign = "center";
        ctx.fillText(""+this.input.lugar, (canvas.width/2)-490, 320+60);
        ctx.fillText(""+d, (canvas.width/2)-350, 320+60);
        ctx.fillText(""+m, (canvas.width/2)-275, 320+60);
        ctx.fillText(""+a, (canvas.width/2)-205, 320+60);

        ctx.font = "38px Arial";
        ctx.fillText("N° 000"+this.numero, (canvas.width/2), 340+70);

        ctx.font = "27px Arial";
        ctx.fillText(''+this.input.monto, (canvas.width/2)+400, 280+50);
        ctx.fillText('_____', (canvas.width/2)+410, 320+60);

        ctx.fillText(''+this.input.estudiante, (canvas.width/2)-40, 443+84);
        ctx.fillText(''+this.input.num_doc, (canvas.width/2)+410, 443+84);
        ctx.fillText(''+this.input.direccion, (canvas.width/2)-315, 506+95);
        ctx.fillText(''+this.input.zona, (canvas.width/2)-10, 506+95);
        if( this.input.nro_factura ){
            ctx.fillStyle = "#ffffff";
            ctx.fillText('____', (canvas.width/2)+389, 505+95);
            ctx.font = "bold 22px verdana, sans-serif";
            ctx.fillStyle = "#1A2D60";
            ctx.fillText('Fact.:', (canvas.width/2)+390, 509+95);
            ctx.font = "27px Arial";
            ctx.fillStyle = "#000000";
            ctx.fillText(''+this.input.nro_factura, (canvas.width/2)+490, 506+95);
            ctx.fillText(''+this.input.celular, (canvas.width/2)+235, 506+95);
        }else{
            ctx.fillText(''+this.input.celular, (canvas.width/2)+360, 506+95);
        }
        ctx.fillText(''+this.input.concepto, (canvas.width/2)+70, 557+107);
        ctx.fillText(''+this.input.forma_pago, (canvas.width/2)+60, 614+117);
        ctx.fillText(''+this.input.monto+' Bs.', (canvas.width/2)-430, 664+125);
        if( this.input.saldo ) ctx.fillText(''+this.input.saldo+' Bs.', (canvas.width/2)-130, 664+125);
        ctx.fillText(''+this.input.num_cuota, (canvas.width/2)+150, 664+125);
        ctx.fillText(''+this.input.proximo_pago, (canvas.width/2)+490, 664+125);
        ctx.fillText(''+this.input.asesor, (canvas.width/2)-250, 710+135);
        ctx.fillText(''+this.input.emisor, (canvas.width/2)+350, 710+135);
        ctx.save();

        ctx.font = "bold 20px verdana, sans-serif";
        ctx.fillStyle = "#08235b";
        ctx.fillText('Lic. '+this.input.emisor, (canvas.width/2)+410, 1045);
        ctx.restore();

        this.previewCertificado( canvas );
    },
    previewCertificado( canvas ){
        var modalsize = document.getElementById("content-preview").getBoundingClientRect();
        var a = (((modalsize.width+160) * 100) / canvas.width)/100;
        var destinationCanvas = document.getElementById("myCanvasview");
        var destCtx = destinationCanvas.getContext('2d');
        destinationCanvas.width = canvas.width;
        destinationCanvas.height = canvas.height/2;
        destCtx.scale(a, 0.5);
        destCtx.drawImage(canvas, 0, 0);
    },
    limpiarDatos(){
        this.generado = false;
        for (var propName in this.input) { 
            if( typeof(this.input[propName]) == 'string') this.input[propName] = '';
            else this.input[propName] = null;
        }
        this.fechahoy();
        this.fechaproximopago();
        this.getcurrentusuario();
    },
    validar(e){
        e.preventDefault();
        if(!this.cajaabierta){
            this.$root.$notify.show(`No hay caja aperturada`, {color:'red',y: 'right',});
            return;
        }
        if( this.generando ) return;
        window.localStorage.setItem( 'recibocacheado',JSON.stringify(this.input) );
        window.console.log('>>>',this.input);
        this.msg = '';
        let xinput = window.Object.assign( {},this.input );
        xinput.fecha_pago = this.voltearfecha( xinput.fecha_pago );
        xinput.proximo_pago = this.voltearfecha( xinput.proximo_pago );
        let errores = '';
        for (var propName in xinput) { 
            if (!xinput[propName] || xinput[propName] === null || xinput[propName] === undefined) { delete xinput[propName]; }
            else {
                if( (typeof(xinput[propName]) == 'string' && propName != 'num_cuota' ) && xinput[propName].length < 5 ){
                    errores += `El campo ${propName} debe ser de al menos 5 caracteres.\n\n`;
                }
                if( propName == 'proximo_pago' && !/^[0-9]{4}-[0-9]{2}-[0-9]{2}$/.test(xinput[propName]) ){
                    errores += `El campo ${propName} no cumple el patron: dd/mm/aaaa.\n\n`;
                }
            }
        }
        if( !xinput.estudiante ) errores += `Falta selecccionar al estudiante puede hacerlo por su carnet.\n\n`;
        if( !xinput.monto ) errores += `El campo monto debe tener un valor numerico y ser mayor a cero.\n\n`;
        if(!this.input.sede_destino) errores += `seleccione la sede destino\n\n`;
        if (isNaN(this.input.nro_factura)) errores += `El numero de factura debe ser un numero valido, sin letras ni espacios\n\n`;
        if (isNaN(this.input.num_cuota)) errores += `El numero de cuota debe ser un numero valido, sin letras ni espacios\n\n`;
        if (isNaN(this.input.celular)) errores += `El numero de celular debe ser un numero valido, sin letras ni espacios\n\n`;
        if (isNaN(this.input.telefono)) errores += `El numero de telefono debe ser un numero valido, sin letras ni espacios\n\n`;
        if(this.input.sede_destino) xinput.sede_destino_id = this.input.sede_destino.id;
        delete xinput.sede_destino;
        delete xinput.telefono;

        if( errores.length == 0 ){
            this.confirmar( xinput );
        }else{
            this.msg = 'ERRORES: '+errores;
        }

        // window.console.log( window.stringifyObject(xinput) );
    },
    confirmar( xinput ){
        const vue = this;
        var message = {
            title:'Confirme que desea proceder',
            body: '<br/>NOTA: El numero de recibo se asigna despues de generar.<br/>'
        };
        var options = {html:true,okText: 'Proceder',cancelText: 'Cancelar',reverse:true,type:'classic',
            verification: 'pagado',verificationHelp: 'Escriba "[+:verification]" para proceder.',loader: true,};
            this.$dialog.confirm(message,options)
            .then(function(dialog) {
                vue.generarrecibo( xinput );
                dialog.close();
            }).catch(function() {});
    },
    generarrecibo( xinput ){
        this.generando = true;
        const vue = this;
        //window.console.log( window.stringifyObject(xinput) );
        var sql = gql`mutation{ generarRecibo(input:${window.stringifyObject(xinput)}){ ok recibo{id,nro_factura,direccion,zona,codigo,nro,lugar,num_doc,estudiante,telefono,celular,concepto,forma_pago,monto,saldo,num_cuota,fecha_registro,fecha_pago,proximo_pago,asesor,emisor},errors{message}} }`;
        
        this.$apollo.mutate({
            mutation: sql,
        }).then(({ data: { generarRecibo } }) => {
            var res = generarRecibo;
            //window.console.log('Recibo generado', res);
            if (res.ok) {
                vue.generado = true;
                vue.numero = res.recibo.nro;
                vue.cargardatos();
                setTimeout(function(){
                    vue.guardarpdf(res.recibo);
                    // vue.generando = false;
                },1000)
            } else {
                var errores = JSON.stringify(res.errors);
                var obj = JSON.parse(errores);
                var vals = '';
                obj.forEach(function (k) { vals += Object.values(k) + '-\n\t'; });
                vue.msg = vals;
                vue.generando = false;           
            }
        }).catch((error) => {
            let err = JSON.parse( JSON.stringify(error) );
            vue.msg = 'SERVER: '+err.graphQLErrors[0].message.message;
            vue.generando = false;
            vue.generado = false;
        });
    },
    async guardarpdf(recibo){
        var canvas = document.getElementById("canvasrecibo");
        let width = canvas.width; 
        let height = canvas.height;
        var pdf;
        var nombre = this.input.estudiante+'-000'+this.numero;

        if (width > height) { pdf = new window.jsPDF('l', 'px', [width, height]); } 
        else { pdf = new window.jsPDF('p', 'px', [height, width]); }

        width = pdf.internal.pageSize.getWidth();
        height = pdf.internal.pageSize.getHeight();
        pdf.addImage(canvas, 'JPG', 0, 0, width, height);
        
        const base64String = pdf.output('datauristring');
        await this.guardarServer(base64String,recibo);
        pdf.save(nombre + '.pdf');
        this.generando = false;
    },
    async guardarServer(b64,recibo){
        // window.console.log("b64",b64,axios);
        let partes = b64.split("base64,");
        let cadenaBase64 = partes[1];

        let data = JSON.stringify({
            "app": process.env.VUE_APP_SERVERFILES_APP,
            "base64": cadenaBase64
        }); 
        
        let config = {
            method: 'post', 
            url: process.env.VUE_APP_SERVERFILES, 
            headers: { 
                'Content-Type': 'application/json'
            },
            data : data
        };

        let res = await xaxios.request(config).then((response) => response.data).catch((error) => error);
        window.console.log(res,recibo);

        let configSave = {
            method: 'put', 
            url: `${process.env.VUE_APP_API_REST}/api/v1/esam/recibo_antiguo/addarchivo`,
            headers: { 
                'Content-Type': 'application/json'
            },
            data : {
                recibo_antiguo_id: recibo.id,
                archivo_id: res.id
            }
        };

        let rese = await xaxios.request(configSave).then((response) => response.data).catch((error) => error);
        window.console.log(rese);
    }
  },
  async mounted(){
      await this.getUsuario();
      this.fechahoy();
      this.fechaproximopago();
      this.getcurrentusuario();
      this.getsedes();
      this.verificar();
    //   window.console.log('this.$store.state',this.$store.state);
      //this.cargarfondo();
      let xr = window.localStorage.getItem('recibocacheado');
      if( xr ) {
        this.input = JSON.parse( xr );
        if( !this.input.recibo_fondo ) this.cargarfondo();
      }
      this.input.sede_id = this.$store.state.CARGO.idsede;
      this.input.sede_destino = null;
      this.limpiarDatos(); 
  }
}
</script>
